import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Form, Modal, Overlay, Popover, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchAllOrgsData, selectAllOrgs, } from "../../redux/actions/getAllOrgsAction";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../API/axios";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";


const UpdateAward = ({ getUserCv, handleCloseUpdateAward, showUpdateAward, userDataId, awardData }) => {
  const dispatch = useDispatch();


  // update Award ..... 

  const [industryDataId, setIndustryDataId] = useState(null);

  useEffect(() => {
    if (awardData) {
      setOrgTypeId(awardData?.issuerOrgType);
      setGetAllOrgsId(awardData?.orgId);
      //setGetAllOrgsId(awardData?.orgName);
      setAwardname(awardData?.name)
      setRecognition(awardData.recognition)
      setIsUseDate(awardData?.issueDate);
      setDescription(awardData?.description);
      // setCitySearch(awardData?.cityId);
      // dispatch(fetchCityData(awardData?.cityName));
      setCitySearch(awardData.cityId || ""); // Backend wali value safe rakho
      setTempCity({ value: awardData.cityId, label: awardData.cityName }); // UI ke liye
    }
  }, [awardData, showUpdateAward]);
  console.log("awardData", awardData);



  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  const [isPresent, setIsPresent] = useState(false);
  const [description, setDescription] = useState("");
  const [awardname, setAwardname] = useState("");
  const [recognition, setRecognition] = useState("");
  const [isuseDate, setIsUseDate] = useState("");
  const [OrgName, setOrgName] = useState("");
  const [InsName, setInsName] = useState("");
  const [display, setDisplay] = useState(false);

  const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Handle changes and mark form as modified
  const handleFieldChange = (setter, value) => {
    setter(value);
    setFormChanged(true); // Enable Submit button
  };

  const handleModalClose = () => {
    setTempCity({ value: citySearch, label: cityList.find(c => c.value === citySearch)?.label || awardData.cityName });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    setIsSubmitting(true); // Disable the button during submission
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      // issuerOrgType: getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,
      // orgID: orgType === '' || orgType === 0 ? neworgType : orgType,

      orgID: getallorgsId === "" ? neworgId : getallorgsId,
      issuerOrgType: regdType
        ? (regdType === 1 ? 1 : regdType === 2 ? 2 : regdType === 3 ? 3 : regdType === 4 ? 4 : regdType === 5 ? 5
          : null)
        : 5,

      name: awardname,
      recognition: recognition,
      issueDate: moment(isuseDate).format("YYYY-MM-DD"),
      description: description,
      cityId: citySearch,
      awrdId: awardData.usrDataAwrdId

    };
    console.log("body", body);

    if (awardname === '' || recognition === '' || isuseDate === '' || orgTypeId === '') {
      toast.error('Please fill all the required fields')
      setIsSubmitting(false); // Re-enable the button if validation fails
    } else {
      try {
        const res = await
          axios.post("/Resume/UpdateAward", body,
            {
              validateStatus: (status) => status >= 200 && status < 300, // Treat only 200-299 as success
            });

        console.log("res=====>", res);

        toast.success(res.data.message);
        handleCloseUpdateAward();
        getUserCv();
        setAwardname();
        setIsUseDate();
        setRecognition();
        setCitySearch();
        setDescription();
        setFormChanged(false); // Disable the button after update
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      } finally {
        setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
      }
    }
  };

  // Create New award

  const [showCreateAward, setShowCreateAward] = useState(false);
  const handleOpenCreateAward = () => setShowCreateAward(true);
  const handleCloseCreateAward = () => setShowCreateAward(false);


  //   Get organization
  const [regdType, setRegdType] = useState("");
  const [getallorgsId, setGetAllOrgsId] = useState("");
  const [orgTypeId, setOrgTypeId] = useState("");
  const { getallorgsList, selectedgetallId } = useSelector(
    (state) => state.getallorgs
  );
  const reversedOrgList = useMemo(() => {
    return [...getallorgsList].reverse(); // Create a new reversed copy
  }, [getallorgsList]);

  useEffect(() => {
    dispatch(fetchAllOrgsData());

  }, [dispatch]);
  console.log("getallorgsList", getallorgsList);


  const handleOrganization = (selectedOption) => {
    console.log("Selected Update Org===>", selectedOption)
    if (selectedOption) {
      // dispatch(selectAllOrgs(selectedOption.value));
      setGetAllOrgsId(selectedOption.value);
      setOrgTypeId(selectedOption.tagId);
      setRegdType(selectedOption.tagId);

    } else {
      setGetAllOrgsId(null);
    }
  };

  console.log('industryDataId', industryDataId, awardData);

  // ...............................City DDL.......................................


  const [orgCity, setOrgCity] = useState(null);
  const [neworgType, setneworgType] = useState('');
  const [neworgId, setneworgId] = useState('');
  const [citySearch, setCitySearch] = useState(null);
  const [tempCity, setTempCity] = useState(null);

  const [searchTerm, setSearchTerm] = useState("")
  const [cityNameOption, setCityNameOption] = useState([])
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
    // return () => {
    //   dispatch(clearCityList())
    // }
  }, [dispatch]);
  const handleCityInputChange = (inputValue) => {
    dispatch(fetchCityData(inputValue));
  };

  const handleCityChange = (option) => {
    setTempCity(option); // UI ke liye value change karo
    // if (option) setCitySearch(option.value); // Sirf tab update ho jab user select kare
    handleFieldChange(setCitySearch, option ? option.value : "");
  };


  // const handleCity = (selectedOption) => {
  //   if (selectedOption) {
  //     // dispatch(selectCity(selectedOption.value));
  //     setCitySearch(selectedOption.value);
  //   } else {
  //     setCitySearch(null);
  //   }
  // };


  const getCityList = async (pageNumber = 1, pageSize = 10) => {
    try {
      const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
        pageNumber,
        pageSize
      })
      console.log("Get City Name List==>", response)
      const cityList = response.data.responseData.citiesDDL.map((val) => ({
        value: val.id,
        label: val.name,
      }));
      setCityNameOption(cityList)
    }
    catch (error) {
      //toast.error(error.message || 'Something went wrong while fetching city data',)
    }
  }

  useEffect(() => {
    getCityList();
  }, [searchTerm]);

  const handleCitySelectOrg = (selectedOption) => {
    setOrgCity(selectedOption ? selectedOption.value : "")
    console.log("Selected City:", selectedOption);
    setSearchTerm("");
    setCityNameOption([]);
  };


  const [OrganizationName, setOrganizationName] = useState("");
  const [getOrgInsTId, setGenOrgInstId] = useState(null);
  const handleSaveInstitution = async () => {
    // setDisplay(true);

    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdGeneralOrg");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);

    try {
      const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("res", res);
      dispatch(fetchAllOrgsData());
      setGenOrgInstId(res.data.responseData);
      //setneworgType(res.data.responseData.value)
      //setneworgId(res.data.responseData.id)
      toast.success(`${res.data.message} The newly created Organization is now available at the top of the dropdown. Please select it.`);
      setOrganizationName("")
      setInsName("")

      // **Enable the submit button after saving**
      setFormChanged(true);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // ...................file selecting............... 

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };

  // ...................toolTip............... 
  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);

  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };


  return (
    <>
      <Modal show={showUpdateAward} onHide={handleCloseUpdateAward} centered size="lg">
        <Modal.Header >
          <Modal.Title>Update award</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseUpdateAward} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Row>

            <Col md={6} className="mb-2">
              <Form.Group controlId="Awards">
                <Form.Label className="class-type">Award name{" "}<span style={{ color: "red" }}> *</span></Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={awardname}
                  // onChange={(e) => setAwardname(e.target.value)}
                  onChange={(e) => handleFieldChange(setAwardname, e.target.value)} // Track changes
                  placeholder="Enter award name"
                />
                {/* {display && !awardname ? (
                  <span className="error_msg_lbl">Add Project Name </span>
                ) : null} */}
              </Form.Group>

            </Col>

            {/* Organization */}
            <Col md={6} className="mb-2">

              <Form.Group controlId="addorganization">
                <Form.Group controlId="organization">
                  <Form.Label className="class-type">
                    Organization<span style={{ color: "red" }}> *</span>
                  </Form.Label>
                  {/* {InsName !== "" ? (
                    <div>
                      <input
                        type="text"
                        value={InsName}
                        placeholder="Enter org name"
                        className="mb-2 form-control Dark-Input-from-group"
                        disabled
                      />
                    </div>
                  ) : (
                    <div className="post-form-group">
                      <ReactSelect
                        options={reversedOrgList}
                        onChange={(selectedOption) =>
                          handleFieldChange(handleOrganization, selectedOption)} // Track changes

                        formatOptionLabel={(option) => (
                          <div style={{ fontWeight: option.tagId === 1 || option.tagId === 2 ? "bold" : "normal" }}>
                            {option.label} <span>({option.tagId === 1 ? "Insitution" : option.tagId === 2 ? "Company" : option.tagId === 3 ? "UnredgCompany" : option.tagId === 4 ? "UnredgInstitution" : option.tagId === 5 ? "UnRegdGeneralOrg" : ""})</span>
                          </div>
                        )}
                        value={
                          reversedOrgList.find(
                            (option) => {

                              if (InsName !== "" && InsName !== null) {

                                return option.value === InsName;
                              } else {

                                return option.value === getallorgsId && option.tagId === orgTypeId;
                              }
                            }
                          ) || null
                        }
                        // value={
                        //   getallorgsList.find(
                        //     (option) => option.value === getallorgsId
                        //   ) || null
                        // }
                        placeholder="Select organization"
                        classNamePrefix="react-select"
                        className="form-control Dark-Input-from-group"
                        styles={customStyles}
                        isClearable
                      />
                    </div>
                  )} */}
                  <div className="form-group">
                    {/* Remove the conditional rendering that switches between input and dropdown */}
                    <div className="post-form-group">
                      <ReactSelect
                        options={reversedOrgList}
                        // onChange={(selectedOption) => handleOrganization(selectedOption)}
                        onChange={(selectedOption) =>
                          handleFieldChange(handleOrganization, selectedOption)
                        }
                        value={
                          reversedOrgList.find(
                            (option) => {
                              // Check if we should use a newly created org or one from the list
                              if (InsName !== "" && InsName !== null) {
                                // This should match the newly created org in the list
                                return option.value === InsName;
                              } else {
                                // This matches existing orgs as before
                                return option.value === getallorgsId && option.tagId === orgTypeId;
                              }
                            }
                          ) || null
                        }
                        getOptionValue={(option) => `${option.value}-${option.tagId}`}
                        formatOptionLabel={(option) => (
                          <div style={{ fontWeight: option.tagId === 1 || option.tagId === 2 ? "bold" : "normal" }}>
                            {option.label}<span>({option.tagId === 1 ? "Insitution" : option.tagId === 2 ? "Company" : option.tagId === 3 ? "UnredgCompany" : option.tagId === 4 ? "UnredgInstitution" : option.tagId === 5 ? "UnRegdGeneralOrg" : ""})</span>
                          </div>
                        )}
                        placeholder="Select Organization"
                        classNamePrefix="react-select"
                        className="form-control Dark-Input-from-group"
                        styles={customStyles}
                        isClearable
                      />
                    </div>
                  </div>
                </Form.Group>
                <a
                  href="#"
                  ref={targetRef}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTooltip();
                  }}
                  className="createModal"
                // isDisabled={!selectedIndustryId} // Disable until industry is selected
                >
                  Create New
                </a>
                <Overlay
                  target={targetRef.current}
                  show={showTooltip}
                  placement="right"
                  rootClose
                  container={document.querySelector(".modal")}
                  onHide={() => setShowTooltip(false)} // Close when clicking outside
                >
                  <Popover id="popover-basic" className="overlay-popover-modal">
                    <Popover.Header as="h3" className="Dark-Body-Card-group">Create organization</Popover.Header>
                    <Popover.Body className="Dark-Body-Card-group">
                      <Form>
                        <div>
                          <label className="mb-1 Text-mb-Create">Org name</label>
                          <input
                            type="text"
                            value={OrganizationName}
                            onChange={(e) => {
                              setOrganizationName(e.target.value)
                              //setOrgName(e.target.value);
                              setInsName(e.target.value)
                            }}
                            placeholder="Enter Org name"
                            className="mb-2 form-control Dark-Input-from-group"
                          />
                        </div>

                        <div>
                          <label className="mb-1 Text-mb-Create">City</label>
                          <ReactSelect
                            options={cityNameOption}
                            onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
                            onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
                            placeholder="Search & select city"
                            classNamePrefix="react-select"
                            className="form-control Dark-Input-from-group"
                            styles={customStyles}
                            isClearable
                          />
                        </div>
                        <div className=" mt-2 mb-2 Text-mb-Create">
                          <label className="mb-1">Org logo</label>
                          <input
                            type="file"
                            id="lastName"
                            className="form-control Dark-Body-Card-group"
                            placeholder=""
                            onChange={handleFileChange}

                          />

                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              handleSaveInstitution()
                              setShowTooltip(false)
                            }
                            }

                            className="me-2"
                          >
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => setShowTooltip(false)}
                          >
                            Cancel
                          </Button>
                        </div>
                      </Form>
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </Form.Group>
            </Col>

            {/* Recognition */}
            <Col md={6} className="mb-2">

              <Form.Group controlId="recognition">
                <Form.Label className="class-type"> Recognition{" "}
                  <span style={{ color: "red" }}>  *</span></Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={recognition}
                  // onChange={(e) => setRecognition(e.target.value)}
                  onChange={(e) => handleFieldChange(setRecognition, e.target.value)} // Track changes
                  placeholder="Enter recognition name"
                />
                {/* {display && !recognition ? (
                  <span className="error_msg_lbl">Add Recognition </span>
                ) : null} */}
              </Form.Group>
            </Col>

            {/* City */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="city">
                <Form.Label className="class-type">
                  City <span style={{ color: "red" }}> *</span>
                </Form.Label>
                <div className="post-form-group">
                  <ReactSelect
                    // options={cityList}
                    // // onChange={handleCity}
                    // onInputChange={handleCityInputChange}
                    // onChange={(option) => handleFieldChange(setCitySearch, option ? option.value : "")} // Track changes
                    // value={
                    //   cityList.find(
                    //     (option) => option.value === citySearch
                    //   ) || null
                    // }
                    // placeholder="Search & Select City"
                    // classNamePrefix="react-select"
                    // className="form-control Dark-Input-from-group"
                    // styles={customStyles}
                    // isClearable

                    options={cityList}
                    onInputChange={handleCityInputChange}
                    onChange={handleCityChange}
                    value={tempCity} // UI me last selected value dikhani hai
                    placeholder="Search & select city"
                    classNamePrefix="react-select"
                    className="form-control Dark-Input-from-group"
                    styles={customStyles}
                    isClearable={true}
                    onBlur={handleModalClose} // Jab modal close ho ya focus hatayen, pehli value restore ho
                  />
                </div>
                {/* {display && !citySearch ? (
                  <span className="error_msg_lbl">Add City</span>
                ) : null} */}
              </Form.Group>
            </Col>


            {/* Issue Date */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
                <Form.Label className="class-type col-md-12">
                  Issue date<span className="text-danger"> *</span>
                </Form.Label>
                <Flatpickr
                  type="number"
                  id="issueDate"
                  value={isuseDate}
                  // onChange={(date) => setIsUseDate(date[0])}
                  onChange={(date) => handleFieldChange(setIsUseDate, (date[0]))} // Track changes
                  placeholder="Enter date"
                  className="Dark-Input-from-group"
                  options={{
                    maxDate: new Date(), // Disable future dates
                    static: true, // Keeps the calendar visible on click         
                  }}
                />
                {/* {display && !isuseDate ? (
                  <span className="error_msg_lbl">Add Date</span>
                ) : null} */}
              </Form.Group>
            </Col>

          </Row>

          <Row>
            <Col md={12} className="mb-2">
              <Form.Group controlId="description">
                <Form.Label className="class-type">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  id="about"
                  className="Dark-Input-from-group"
                  rows={3}
                  value={description}
                  // onChange={(e) => setDescription(e.target.value)}
                  onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
                  placeholder="Enter description"
                />
                {/* {display && !description ? (
                  <span className="error_msg_lbl">Add Description  </span>
                ) : null} */}
              </Form.Group>
            </Col>
          </Row>
          {/* Submit and Close Buttons */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
              onClick={handleSubmit}
              style={{ cursor: formChanged ? "pointer" : "default" }}
            >
              <a href="#/"
                // className="" 
                // onClick={handleSubmit}
                className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                disabled={!formChanged || isSubmitting}
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
              >
                Submit
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>



      <Modal
        show={showCreateAward}
        onHide={handleCloseCreateAward}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Award</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* Certificate Name */}
            <Col md={12}>
              <div className="post-form-group mb-1">
                <label htmlFor="certificateName">
                  Award Name{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </label>
                <input type="text" placeholder="Enter certificate name" />
              </div>
            </Col>
          </Row>

          {/* Submit and Close Buttons */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="" onClick={handleSubmit}>
                Save
              </a>
            </div>
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="">
                Close
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UpdateAward